'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = analyticsPage;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _rpAnalytics = require('rp-analytics');

var segmentio = _interopRequireWildcard(_rpAnalytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function analyticsPage() {
    var _segmentio$setCommonT;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var pageTraits = {};
    var permutiveProps = { article: {} };
    var hasPermutiveProps = false;

    segmentio.setCommonTraits((_segmentio$setCommonT = {}, (0, _defineProperty3.default)(_segmentio$setCommonT, segmentio.TRAIT_SITE_SECTION, (0, _jquery2.default)('[data-site-section]').attr('data-site-section')), (0, _defineProperty3.default)(_segmentio$setCommonT, segmentio.TRAIT_SITE_SUB_SECTION_1, (0, _jquery2.default)('[data-site-sub-section-1]').attr('data-site-sub-section-1')), (0, _defineProperty3.default)(_segmentio$setCommonT, segmentio.TRAIT_SITE_SUB_SECTION_2, (0, _jquery2.default)('[data-site-sub-section-2]').attr('data-site-sub-section-2')), _segmentio$setCommonT));

    var articleId = (0, _jquery2.default)('[data-article-id]').attr('data-article-id');
    var articlePublishedDate = (0, _jquery2.default)('[data-article-published-date]').attr('data-article-published-date');
    var originalArticlePublishedDate = (0, _jquery2.default)('[data-article-original-published-date]').attr('data-article-original-published-date');
    var articleName = (0, _jquery2.default)('[data-article-name]').attr('data-article-name');
    var articleAuthor = (0, _jquery2.default)('[data-article-author]').attr('data-article-author');

    if (articleId) {
        pageTraits['Article ID'] = articleId;
        permutiveProps.article.id = articleId;
        hasPermutiveProps = true;
    }

    if (articlePublishedDate) {
        pageTraits['Article Published Date'] = articlePublishedDate;
        permutiveProps.article.publishedAt = articlePublishedDate;
        hasPermutiveProps = true;
    }

    if (originalArticlePublishedDate) {
        pageTraits['Original Article Published Date'] = originalArticlePublishedDate;
        permutiveProps.article.OriginalPublishedAt = originalArticlePublishedDate;
        hasPermutiveProps = true;
    }

    if (articleName) {
        pageTraits['Article Name'] = articleName;
        permutiveProps.article.title = articleName;
        hasPermutiveProps = true;
    }

    if (articleAuthor) {
        pageTraits['Article Author'] = articleAuthor;
        permutiveProps.article.authors = [articleAuthor];
        hasPermutiveProps = true;
    }

    pageTraits = _jquery2.default.extend({}, traits, pageTraits);
    permutiveProps = hasPermutiveProps ? permutiveProps : {};

    var pageName = null; // not used for now
    segmentio.page(pageName, pageTraits, segmentio.page.DEFAULT_OPTIONS, permutiveProps);
}


//////////////////
// WEBPACK FOOTER
// ./public/js/analyticsPage.js
// module id = 642
// module chunks = 0